import { render, staticRenderFns } from "./appoint_details.vue?vue&type=template&id=5124306c&scoped=true&"
import script from "./appoint_details.vue?vue&type=script&lang=js&"
export * from "./appoint_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5124306c",
  null
  
)

export default component.exports